// CompanyCreation wizard — step 3: pick features to enable (multi-select).

import { useTranslation } from 'react-i18next';
import { features } from '@/mocks/onboarding';
import OptionCard from './OptionCard';
import type { CompanyCreationData } from './company-creation-types';

interface StepProps {
  data: CompanyCreationData;
  onToggleFeature: (id: string) => void;
}

const CompanyCreationStepFeatures = ({ data, onToggleFeature }: StepProps) => {
  const { t } = useTranslation();

  return (
    <div className='company-creation__grid company-creation__grid--features'>
      {features.map((feature) => (
        <OptionCard
          key={feature.id}
          icon={feature.icon}
          label={t(feature.labelKey)}
          selected={data.features.includes(feature.id)}
          accent
          onClick={() => onToggleFeature(feature.id)}
        />
      ))}
    </div>
  );
};

export default CompanyCreationStepFeatures;
